<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="employee_id != null"
>
    <v-card>
        <v-card-title>Grant Access to Organization</v-card-title>



        <v-card-text>

            <v-text-field
                label="Grant"
                :value="employee_label + ' ('+employee_username+')'"
                readonly
            />

            <m-autocomplete
                label="Access to Organization"
                v-model="grant_access_to_organization_id"
                type="organization"
            />

            <v-checkbox
                label="As Organization Administrator"
                v-model="as_organization_admin"
            />

            <v-text-field
                label="Confirm"
                v-model="confirm_text"
                hint="type 'confirm'"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Grant Access
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            grant_access_to_organization_id: null,
            as_organization_admin: false,
            confirm_text: null,
            
            employee_id: null,
            employee_username: null,
            employee_label: null,
        }
    },

    methods: {

        showDialog(employee_id, employee_username, employee_label)
        {
            this.employee_id = employee_id;
            this.employee_username = employee_username;
            this.employee_label = employee_label;

            this.grant_access_to_organization_id = null;
            this.as_organization_admin = false;
            this.confirm_text = null;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/employees/grant-access-to-organization',
            
                'params' : {
                        'grant_access_to_organization_id': this.grant_access_to_organization_id,
                        'as_organization_admin': this.as_organization_admin,
                        'employee_id': this.employee_id,
                    },
            
                'on_success': (data) => {
                        this.$rc.alert('Access Granted', 'The access you requested has been granted.<br/><br/>Remember that you still need to configure the home phone number for this account');

                        this.$emit('update');
                    },
            
                'on_error': 'Unable to grant access to organization',
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        is_valid() {
            if ( this.grant_access_to_organization_id == null ) return false;
            if ( this.confirm_text == null ) return false;
            if ( this.confirm_text.toLowerCase() != 'confirm' ) return false;

            return true;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>